$(document).ready(function() {
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.slider-nav',
        speed: 500,
        arrows: true,
        adaptiveHeight: true,
        autoplay: true,
        fade: true,
        dots: true,
        appendDots: $('.dots-container'),
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    adaptiveHeight: false,
                    dots: true,
                }
            }
        ],
        prevArrow: $('.press-text .prev'),
        nextArrow: $('.press-text .next'),
    });

    $('.slider-nav').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      arrows: false,
      centerMode: true,
      infinite: true,
      centerPadding: '0px',
      responsive: [
        {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              centerPadding: '25%',
            }
        }
    ],
    });
})
